export var ScheduleStatus;
(function (ScheduleStatus) {
    /** Item is scheduled for a future date. */
    ScheduleStatus["SCHEDULED"] = "SCHEDULED";
    /** Item is canceled. */
    ScheduleStatus["CANCELED"] = "CANCELED";
})(ScheduleStatus || (ScheduleStatus = {}));
export var StateFilter;
(function (StateFilter) {
    /** Schedule item is published. */
    StateFilter["PUBLISHED"] = "PUBLISHED";
    /** Opposite of `PUBLISHED`. Requires `WIX_EVENTS.READ_HIDDEN_AGENDA` permission. */
    StateFilter["DRAFT"] = "DRAFT";
    /** Schedule item is visible to the public. */
    StateFilter["VISIBLE"] = "VISIBLE";
    /** Opposite of `VISIBLE`. Requires `WIX_EVENTS.READ_HIDDEN_AGENDA` permission. */
    StateFilter["HIDDEN"] = "HIDDEN";
})(StateFilter || (StateFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map